import { PageProps } from 'gatsby';
import { DashboardLayout } from 'modules/dashboard';
import React from 'react';
import { useIntl } from 'react-intl';
import { PageLoading, SEO } from 'shared/components';
import { useProposalsLoadingSelector } from '../state';
import { ProposalsSection } from './ProposalsSection';

interface Props extends PageProps {
  publishStatus: PublishStatus;
}

export const Proposals: React.FC<Props> = ({ location, publishStatus }) => {
  const { formatMessage } = useIntl();
  const loading = useProposalsLoadingSelector();

  if (loading) return <PageLoading isLoading={loading} />;

  return (
    <>
      <SEO
        title={formatMessage({ id: 'proposals.seo.title' })}
        description={formatMessage({ id: 'proposals.seo.description' })}
        href={location.href}
      />
      <DashboardLayout>
        <ProposalsSection publishStatus={publishStatus} />
      </DashboardLayout>
    </>
  );
};
